/* unplugin-vue-components disabled */import { render } from "./SpeachManageTranslationsModal.vue?vue&type=template&id=799dd870&scoped=true&ts=true"
import script from "./SpeachManageTranslationsModal.vue?vue&type=script&lang=ts"
export * from "./SpeachManageTranslationsModal.vue?vue&type=script&lang=ts"

import "./SpeachManageTranslationsModal.vue?vue&type=style&index=0&id=799dd870&scoped=true&lang=scss"
import "./SpeachManageTranslationsModal.vue?vue&type=style&index=1&id=799dd870&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799dd870"]])

export default __exports__